import { ReportFeatures } from '@hcs/types';

export const SUBJECT_MAIN_DETAILS_FEATURES = [
  ReportFeatures.SubjectPropertyDetails,
];
